$(document).ready(function() {

	// Mobile Menu Logic
	// Open nav
	$('.hamburger').on('click', function(e) {
		e.preventDefault();
		$('.nav-mobile-wrap').css('width', '300px');
	});
	// Close nav
	$('.btn-close-nav').on('click', function(e) {
		e.preventDefault();
		$('.nav-mobile-wrap').css('width', '0');
	});
	// Mobile Nav Dropdown logic
	$('.nav-mobile-wrap .dropdown > a').on('click', function(e) {
		e.preventDefault();
		$(this).siblings('ul').slideToggle(400);
	});

	// Initiating Sliders

	$('.slider.primary-slider').slick({
		pauseOnHover: true,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: false,
		speed: 500,
		adaptiveHeight: true,
		prevArrow : '<div class="prev-arrow"><i class="fa fa-chevron-left"></i></div>',
		nextArrow : '<div class="next-arrow"><i class="fa fa-chevron-right"></i></div>'
	});
	$('.slider.secondary-slider').slick({
		pauseOnHover: true,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: false,
		speed: 500,
		infinite: true,
  	slidesToShow: 6,
  	slidesToScroll: 3,
		prevArrow : '<div class="prev-arrow"><i class="fa fa-chevron-left"></i></div>',
		nextArrow : '<div class="next-arrow"><i class="fa fa-chevron-right"></i></div>'
	});

	// To make the QTY buttons work

	$(function() {

		$(".btn-qty").on("click", function() {
			var $button = $(this);
			var oldValue = $button.parent().find("input").val();

			if ($button.hasClass('inc')) {
				var newVal = parseFloat(oldValue) + 1;
			} else {
				// Don't allow decrementing below one
				if (oldValue > 1) {
					var newVal = parseFloat(oldValue) - 1;
				} else {
					newVal = 1;
				}
			}
		$button.parent().find("input").val(newVal);
		});
	});

	// Zoom plugin here

	$('.featured-image').zoom({
		url: $('.featured-image img').attr('data-zoom')
	});

	// Account/Customer Logic

	$('.forgot-password').on('click', function(e) {
		e.preventDefault();
		showRecoverPasswordForm();
	});
	$('.recover-password-cancel').on('click', function(e) {
		e.preventDefault();
		hideRecoverPasswordForm();
	});

	function showRecoverPasswordForm() {
		$('#recover-password').css('display', 'block');
		$('#customer').css('display', 'none');
	}

	function hideRecoverPasswordForm() {
		$('#recover-password').css('display', 'none');
		$('#customer').css('display', 'block');
	}

	if (window.location.hash == '#recover') { showRecoverPasswordForm() }

});
